import { createSelector } from 'reselect';
import { Organization } from 'store/global/types';

const getOrganizations = (state: any) => state.getIn(['organizations', 'get']);

const mapOrganization = (organization: any): Organization => ({
  subscriber: organization.NOM_SOUSCRIPTEUR,
  policyNumber: organization.NUM_POLICE,
  isdrpp: organization.TYPE_SOUSCRIPTEUR,
  type: organization.TYPE_ORGANISME,
  numAdhesion: organization.PMI,
});

export const getOrganizationsSelector = createSelector(
  getOrganizations,
  ({ data, ...rest }) => ({
    ...rest,
    data: data?.map(mapOrganization),
  }),
);
